import { useRouter } from 'next/router';
import React from 'react';

import {
  countOfLiveOrder,
  isCourierOrder,
  orderCrn,
} from '../helpers/OrderHistoryLoadable';
import { internal_path } from '../vm/HeaderStore';

import LinkTrackOrdersCmp from './LinkTrackOrdersCmp';
import { make as MobileLoginCmpMjs } from './MobileLoginCmp.mjs';

const MobileLoginCmp = MobileLoginCmpMjs as React.FC;

interface MobileMenuAuthSectionProps {
  isBookingFlowEnabled: boolean;
  is_authenticated: boolean;
  order_history: unknown;
}

function MobileMenuAuthSection({
  isBookingFlowEnabled,
  is_authenticated,
  order_history,
}: Readonly<MobileMenuAuthSectionProps>): React.ReactElement | null {
  const router = useRouter();
  const showLogin = isBookingFlowEnabled || router.pathname === internal_path;

  if (is_authenticated) {
    return (
      <>
        <MobileLoginCmp />
        <LinkTrackOrdersCmp
          count_of_ongoing_order={countOfLiveOrder(order_history)}
          order_crn={orderCrn(order_history, 0)}
          is_courier_order={isCourierOrder(order_history, 0)}
        />
      </>
    );
  }

  if (showLogin) {
    return <MobileLoginCmp />;
  }

  return null;
}

export default MobileMenuAuthSection;
